import { Observable } from 'rxjs';
import { UseCase } from '@/core/base/use-case';
import { CrpInterface } from '../models/crp.model';
import { CrpRepository } from '../repositories/crp.repository';
import { crpInternational } from '../models/crp-body';

export class PostCrpUseCase implements UseCase<crpInternational, CrpInterface> {
    constructor(private readonly repository: CrpRepository) {}

    execute(crpInternational: crpInternational): Observable<CrpInterface> {
        return this.repository.postCrp(crpInternational);
    }
}
